<script>
import Workflow from './Workflow'
import WorkflowExecution from './WorkflowExecution'
export default {

  props: {
    action: {
      type: Object
    },
    value: { type: String }
  },

  data() {
    let workflow = Workflow.storage.find(this.action.template().workflowUuid)
    let collection = WorkflowExecution.storage.findAll(this.action.template().workflowUuid, 'workflow_id').reverse()
    return {
      workflow: workflow,
      collection: collection,
      internalValue: this.value
    }
  },

  mounted() {
    if (!this.internalValue && this.collection.length > 0) {
      this.internalValue = this.collection[0].uuid
    }
  },

  computed: {
    message() {
      if (this.collection.length == 0) {
        return `Please run workflow "${this.workflow.name}" first`
      }
    }
  },

  watch: {
    internalValue() {
      this.$emit('input', this.internalValue)
    }
  }



}
</script>

<template>
  <div>
    <b-field :label="workflow.name" :message="message">
      <b-select v-model="internalValue" v-if="collection.length > 0">
        <option v-for="(item, index) in collection" :value="item.uuid" :key="item.uuid">
          {{ item.name }}
        </option>
      </b-select>
    </b-field>
  </div>
</template>

<style lang="scss">

</style>